import React from 'react';
import PropTypes from 'prop-types';
import { List as ImmutableList } from 'immutable';
import { withStyles } from "tss-react/mui";
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import { CenteredMessage } from 'components/Typography';
import SwipeListItem from '../SwipeListItem';
import ProgressDialog from 'components/ProgressDialog';
import { isDefined, isFunc } from 'utilities/is';

import styles from './styles';

const filterSwipes = (swipes, swipeTypes) =>
    ImmutableList(swipes)
        .filter(s => swipeTypes.indexOf(s.swipeEvent) >= 0)
        .sortBy(s => s.swipeTime)
        .reverse()
        .toArray();

class SwipeListPanel extends React.Component {

    state = {
        progressDialogOpen: false,
        dialogMessage: ""
    };

    showProgress = (message) => {
        this.setState({ progressDialogOpen: true, dialogMessage: message });
    };

    hideProgress = () => {
        this.setState({ progressDialogOpen: false, dialogMessage: "" });
    };

    onSwipeInfoClicked = (swipe) => {
        if (this.props.onSwipeClicked) {
            this.props.onSwipeClicked(swipe);
        }
    };

    swipeList = (swipes, config, location, supervisorData) => {
        return (
            <List className={this.props.classes.swipeList}>
                <Divider />
                {swipes.map((swipe, index) =>
                    <SwipeListItem
                        key={index}
                        swipe={swipe}
                        config={config}
                        location={location}
                        supervisorData={supervisorData}
                        currentFilter={this.props.currentFilter}
                        showProgress={this.showProgress}
                        hideProgress={this.hideProgress}
                        onSwipeInfoClicked={this.onSwipeInfoClicked} />
                )}
            </List>
        );
    };

    emptyState = (swipeRetention) => {
        return (
            <div className={this.props.classes.panelMessage}>
                <CenteredMessage>
                    {this.props.emptyStateMessage(swipeRetention)}
                </CenteredMessage>
            </div>
        );
    };

    emptyFilter = () => {
        return (
            <div className={this.props.classes.panelMessage}>
                <CenteredMessage className={this.props.classes.panelMessage}>
                    {this.props.emptyFilterMessage}
                </CenteredMessage>
            </div>
        );
    };

    renderHeader() {
        const { HeaderComponent } = this.props;

        if (isDefined(HeaderComponent)) {
            return (
                <Grid item xs={12} className={this.props.classes.filterPanel}>
                    {HeaderComponent()}
                </Grid>);
        }

        return (<React.Fragment></React.Fragment>);
    }

    render() {
        const {
            swipes,
            classes,
            config,
            location,
            supervisorData,
            currentFilter,
            additionalFilterFunc,
            showEmptyFilterMessage
        } = this.props;

        const hasSwipes = swipes && swipes.length > 0;
        let filteredSwipes = filterSwipes((swipes || []), currentFilter);

        if (isDefined(additionalFilterFunc) && isFunc(additionalFilterFunc)) {
            filteredSwipes = filteredSwipes.filter(additionalFilterFunc);
        }

        const showEmptyState = !hasSwipes || (filteredSwipes.length === 0 && !showEmptyFilterMessage);
        const showEmptyFilter = hasSwipes && filteredSwipes.length === 0 && showEmptyFilterMessage;

        return (
            <Grid container className={classes.body}>

                <ProgressDialog open={this.state.progressDialogOpen}>
                    {this.state.dialogMessage}
                </ProgressDialog>

                {!showEmptyState &&
                    this.renderHeader()
                }
                <Grid item xs={12} className={classes.body}>
                    {showEmptyState &&
                        this.emptyState(config.swipeHistoryValidityInHours)
                    }
                    {showEmptyFilter &&
                        this.emptyFilter()
                    }
                    {hasSwipes && filteredSwipes.length > 0 &&
                        this.swipeList(filteredSwipes, config, location, supervisorData)
                    }
                </Grid>
            </Grid>
        );
    }
}

const StyledSwipeListPanel = withStyles(SwipeListPanel,styles);

StyledSwipeListPanel.propTypes = {
    emptyStateMessage: PropTypes.func.isRequired,
    emptyFilterMessage: PropTypes.string,
    swipes: PropTypes.arrayOf(PropTypes.object).isRequired,
    config: PropTypes.object.isRequired,
    supervisorData: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    currentFilter: PropTypes.arrayOf(PropTypes.string).isRequired,
    onSwipeClicked: PropTypes.func,
    showEmptyFilterMessage: PropTypes.bool.isRequired,
    HeaderComponent: PropTypes.func

};

export default StyledSwipeListPanel;